/// <amd-module name="SuiteCommerce.SizeChart.Shopping"/>
define("SuiteCommerce.SizeChart.Shopping", ["require", "exports", "SuiteCommerce.SizeChart.Common.Configuration", "SuiteCommerce.SizeChart.PDP", "SuiteCommerce.SizeChart.Chart.Router", "SuiteCommerce.SizeChart.Common.InstrumentationHelper"], function (require, exports, Configuration_1, PDP, Chart_Router_1, InstrumentationHelper_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            var environment = container.getComponent('Environment');
            this.initializeConfiguration(environment);
            this.initializeInstrumentation(environment);
            var router = new Chart_Router_1.ChartRouter({
                application: container,
                routes: {},
            });
            PDP.mountToApp({
                router: router,
                container: container,
            });
        },
        initializeConfiguration: function (environment) {
            Configuration_1.Configuration.environment = environment;
        },
        initializeInstrumentation: function (environment) {
            InstrumentationHelper_1.InstrumentationHelper.initializeInstrumentation(environment);
        },
    };
});
